import {ChangeEvent, FC, useCallback, useRef} from "react";
import Button, {ButtonProps} from "@memaro/components/Button.tsx";
import AddPhotoAlternate from "@mui/icons-material/AddPhotoAlternate";

type UploadButtonProps = ButtonProps & {
    onFilesSelected: (files: File[]) => void
}

const UploadButton: FC<UploadButtonProps> = ({onFilesSelected, ...rest}) => {
    const fileInputRef = useRef<HTMLInputElement | null>(null);

    const handleAdd = useCallback(() => {
        fileInputRef.current?.click();
    }, [])

    const handleChangeFileInput = useCallback((event: ChangeEvent<HTMLInputElement>) => {
        if (event.target.files && event.target.files.length > 0) {
            onFilesSelected([...event.target.files])
        }
        if (fileInputRef.current) {
            fileInputRef.current!.value = ""
        }
    }, [onFilesSelected])

    return (
        <Button onClick={handleAdd} {...rest}>
            <AddPhotoAlternate />
            <span>Foto toevoegen</span>
            <input
                ref={fileInputRef}
                type="file"
                multiple
                accept="image/jpeg, image/png"
                onChange={handleChangeFileInput}
                style={{display: 'none'}}
            />
        </Button>
    )
}


export default UploadButton
